import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=cabdc0bc&scoped=true"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"
import style0 from "./Back.vue?vue&type=style&index=0&id=cabdc0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabdc0bc",
  null
  
)

export default component.exports